import { UpdateSummary } from '@/core/domain/update-category/models/update-summary.model';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class UpdateSummaryService {
    private _updateSummary!: UpdateSummary | undefined;
    public get updateSummary(): UpdateSummary | undefined {
        return this._updateSummary;
    }
    public set updateSummary(v: UpdateSummary | undefined) {
        this._updateSummary = v;
    }
}
